import React from "react";
import { connect } from "react-redux";

import Brands from "./Brands";

const BrandsContainer = props => {
  return <Brands {...props} />;
};

const mapStateToProps = state => {
  return {
    token: state.auth.token
  };
};

export default connect(mapStateToProps)(BrandsContainer);



// WEBPACK FOOTER //
// src/containers/metier/referential/Brands.container.js